//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUpload from '@/components/file-upload'
import DivSpan from '@/components/DivSpan'
export default {
  name: 'bank-info',
  components:{fileUpload,DivSpan},
  props:['supBankList'],
  methods:{
    changeShow(i){
      if(this.supBankList[i].cellShow){
        this.$set(this.supBankList[i],'cellShow',false);
        return;
      }
      this.$set(this.supBankList[i],'cellShow',true);
    }
  },
}



// WEBPACK FOOTER //
// ./src/page/supplier/view/bank-info.vue